export default {"src":"/_next/static/media/sailboat.70bf8f84.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};